export const LOADER_COMPANY_BY_SLUG = "loaders/company-by-slug";
